import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { isMobile } from 'react-device-detect';

const FRONTEND_ENDPOINT = process.env.REACT_APP_FRONTEND_URL;

const InstallAndroid = () => {
  const [qrCode, setQrCode] = useState();

  QRCode.toDataURL(`${FRONTEND_ENDPOINT}/onboarding/android`)
    .then((url) => {

      setQrCode(url);
    })
    .catch((err) => {
      console.error(err);
    });



  return (
    <div className="center">
      <h1>Android Setup Instructions</h1>
      {
        isMobile ? (
          <>
            <div>
              1. Tap the 3-dot button in the corner and "Add to Home screen."
            </div>
            <div>2. After the installation, Tap the 3-dot button again tap the Share button</div>
            <div>3. Scroll, tap "More," and tap "Audioread"</div>

          </>

        ) : (
          <div>
            <h2>Scan the QR code with your Android device to setup Audioread</h2>
            <img
              src={qrCode}
              alt="Android QR code"
              width="250"
              height="auto"
              style={{ margin: "0 30px 30px 30px" }}
            ></img>
          </div>
        )
      }
      <div></div>

    </div>
  );
}

export default InstallAndroid;
